<template>
  <b-card>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Título" label-for="titulo">
            <b-form-input
              id="titulo"
              v-model="eventTask.titulo"
              required
              placeholder="Digite o título da tarefa"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Evento" label-for="evento">
            <v-select
              id="evento"
              v-model="eventTask.evento"
              :options="eventos"
              label="nome"
              :reduce="(evento) => evento"
              placeholder="Selecione o evento"
            >
              <template #no-options>
                <div class="text-muted">Nenhum evento encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Descrição" label-for="descricao">
            <b-form-textarea
              id="descricao"
              v-model="eventTask.descricao"
              placeholder="Digite a descrição da tarefa"
              rows="3"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Responsável" label-for="responsavel">
            <v-select
              id="responsavel"
              v-model="eventTask.responsavel"
              :options="responsaveis"
              label="nome"
              :reduce="(resp) => resp"
              placeholder="Selecione o responsável"
            >
              <template #no-options>
                <div class="text-muted">Nenhum responsável encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Data Prevista" label-for="dataPrevista">
            <flat-pickr
              id="dataPrevista"
              v-model="eventTask.dataPrevista"
              class="form-control"
              :config="dateConfig"
              placeholder="Selecione a data"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventTask.concluida"
            name="concluida"
            switch
            @change="handleConclusaoChange"
          >
            {{ eventTask.concluida ? 'Concluída' : 'Pendente' }}
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" v-if="eventTask.concluida">
          <b-form-group label="Data de Conclusão" label-for="dataConclusao">
            <flat-pickr
              id="dataConclusao"
              v-model="eventTask.dataConclusao"
              class="form-control"
              :config="dateConfig"
              placeholder="Selecione a data de conclusão"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventTask.ativo"
            name="ativo"
            switch
          >
            {{ eventTask.ativo ? 'Ativo' : 'Inativo' }}
          </b-form-checkbox>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BCard,
  BForm,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue';
import { verificarPermissao } from '@/auth/utils';

export default {
  name: 'EventTaskForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BCard,
    BForm,
    vSelect,
    flatPickr,
    ButtonsFormVue,
  },
  data() {
    return {
      verificarPermissao,
      dateConfig: {
        dateFormat: 'Y-m-d',
        locale: 'pt',
      },
      eventos: [],
      responsaveis: [],
    };
  },
  computed: {
    ...mapState('eventTaskSettingsModule', {
      eventTask: (state) => state.eventTask,
    }),
  },
  created() {
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      try {
        // TODO: Replace with actual API calls
        // this.eventos = await this.$http.get('/api/eventos');
        // this.responsaveis = await this.$http.get('/api/usuarios');
      } catch (error) {
        console.error('Error loading dependencies:', error);
      }
    },
    handleConclusaoChange(checked) {
      if (checked) {
        this.eventTask.dataConclusao = new Date().toISOString().split('T')[0];
      } else {
        this.eventTask.dataConclusao = null;
      }
    },
    save() {
      const payload = {
        ...this.eventTask,
        evento: { id: this.eventTask.evento?.id },
        responsavel: { id: this.eventTask.responsavel?.id },
      };

      if (this.eventTask.id) {
        this.$store.dispatch('eventTaskSettingsModule/edit', payload);
      } else {
        this.$store.dispatch('eventTaskSettingsModule/insertNew', payload);
      }
    },
    cancel() {
      this.$emit('cancelar');
      this.$store.dispatch('eventTaskSettingsModule/reset');
    },
  },
};
</script>
